import { useThemeColor } from '@/hooks/useThemeColor';

/**
 * Component that syncs the browser's theme-color meta tag with the current theme.
 * Should be rendered inside ThemeProvider to access theme context.
 */
export function ThemeColorSync() {
  useThemeColor();
  return null;
}
